import type { AppRoute } from "@/lib/routing";

// Owner: C5 (bench, labels and devices). Calibration offsets are edited here or in Settings › Labels.
export const routes: AppRoute[] = [
  {
    path: "/labels",
    lazy: async () => ({ Component: (await import("./pages/LabelsPage")).LabelsPage }),
    handle: { title: "Labels", keywords: ["print", "QR", "avery", "stickers", "thermal", "brother", "niimbot"] },
  },
];
